module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {

	fox.registerWidget('SitePage_Passwordrecovery', {

		configure: function () {
			this.registerOptions('', {
				widgets: {
					passwordRecovery: {
						widget: 'User_PasswordRecovery'
					}
				}
			});

			this.callParent('configure', arguments);
		}

	}, 'Site_Page');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/passwordrecovery.js
// module id = 925
// module chunks = 4